import { nevadaSetupVars } from './nevadaSetupVars'
import { californiaSetupVars } from './californiaSetupVars'
import { pennsylvaniaSetupVars } from './pennsylvaniaSetupVars'
import { headed2SetupVars } from './headed2SetupVars'
import { iowaSetupVars } from './iowaSetupVars'
import { louisianaSetupVars } from './louisianaSetupVars'
import { virginiaSetupVars } from './virginiaSetupVars'
import { arkansasSetupVars } from './arkansasSetupVars'
import { alabamaSetupVars } from './alabamaSetupVars'
import { arizonaSetupVars } from './arizonaSetupVars'
import { connecticutSetupVars } from './connecticutSetupVars'
import { coloradoSetupVars } from './coloradoSetupVars'
import { indianaSetupVars } from './indianaSetupVars'
import { delawareSetupVars } from './delawareSetupVars'
import { floridaSetupVars } from './floridaSetupVars'
import { westVirginiaSetupVars } from './westVirginiaSetupVars'
import { hawaiiSetupVars } from './hawaiiSetupVars'
import { georgiaSetupVars } from './georgiaSetupVars'
import { idahoSetupVars } from './idahoSetupVars'
import { kansasSetupVars } from './kansasSetupVars'
import { kentuckySetupVars } from './kentuckySetupVars'
import { maineSetupVars } from './maineSetupVars'
import { illinoisSetupVars } from './illinoisSetupVars'
import { marylandSetupVars } from './marylandSetupVars'
import { massachusettsSetupVars } from './massachusettsSetupVars'
import { mississippiSetupVars } from './mississippiSetupVars'
import { michiganSetupVars } from './michiganSetupVars'
import { minnesotaSetupVars } from './minnesotaSetupVars'
import { missouriSetupVars } from './missouriSetupVars'
import { montanaSetupVars } from './montanaSetupVars'
import { nebraskaSetupVars } from './nebraskaSetupVars'
import { newJerseySetupVars } from './newJerseySetupVars'
import { newYorkSetupVars } from './newYorkSetupVars'
import { newMexicoSetupVars } from './newMexicoSetupVars'
import { newHampshireSetupVars } from './newHampshireSetupVars'
import { northCarolinaSetupVars } from './northCarolinaSetupVars'
import { northDakotaSetupVars } from './northDakotaSetupVars'
import { ohioSetupVars } from './ohioSetupVars'
import { puertoRicoSetupVars } from './puertoRicoSetupVars'
import { southCarolinaSetupVars } from './southCarolinaSetupVars'
import { southDakotaSetupVars } from './southDakotaSetupVars'
import { rhodeIslandSetupVars } from './rhodeIslandSetupVars'
import { vermontSetupVars } from './vermontSetupVars'
import { wyomingSetupVars } from './wyomingSetupVars'
import { wisconsinSetupVars } from './wisconsinSetupVars'
import { utahSetupVars } from './utahSetupVars'
import { washingtonSetupVars } from './washingtonSetupVars'
import { alaskaSetupVars } from './alaskaSetupVars'
import { texasSetupVars } from './texasSetupVars'
import { tennesseeSetupVars } from './tennesseeSetupVars'
import { districtColumbiaSetupVars } from './districtColumbiaSetupVars'
import { oregonSetupVars } from './oregonSetupVars'

export const guessVars = stateId => {
  let siteVars = headed2SetupVars

  switch (stateId) {
    case 'al':
    case 'alabama':
      siteVars = {
        ...siteVars,
        ...alabamaSetupVars
      }
      break
    case 'ak':
    case 'alaska':
      siteVars = {
        ...siteVars,
        ...alaskaSetupVars
      }
      break
    case 'ar':
    case 'arkansas':
      siteVars = {
        ...siteVars,
        ...arkansasSetupVars
      }
      break
    case 'az':
    case 'arizona':
      siteVars = {
        ...siteVars,
        ...arizonaSetupVars
      }
      break
    case 'ca':
    case 'california':
      siteVars = {
        ...siteVars,
        ...californiaSetupVars
      }
      break
    case 'ct':
    case 'connecticut':
      siteVars = {
        ...siteVars,
        ...connecticutSetupVars
      }
      break
    case 'co':
    case 'colorado':
      siteVars = {
        ...siteVars,
        ...coloradoSetupVars
      }
      break
    case 'dc':
    case 'district_of_columbia':
    case 'districtofcolumbia':
    case 'washingtondc':
    case 'washington_dc':
      siteVars = {
        ...siteVars,
        ...districtColumbiaSetupVars
      }
      break
    case 'de':
    case 'delaware':
      siteVars = {
        ...siteVars,
        ...delawareSetupVars
      }
      break
    case 'fl':
    case 'florida':
      siteVars = {
        ...siteVars,
        ...floridaSetupVars
      }
      break
    case 'ga':
    case 'georgia':
      siteVars = {
        ...siteVars,
        ...georgiaSetupVars
      }
      break
    case 'hi':
    case 'hawaii':
      siteVars = {
        ...siteVars,
        ...hawaiiSetupVars
      }
      break
    case 'ia':
    case 'iowa':
      siteVars = {
        ...siteVars,
        ...iowaSetupVars
      }
      break
    case 'id':
    case 'idaho':
      siteVars = {
        ...siteVars,
        ...idahoSetupVars
      }
      break
    case 'il':
    case 'illinois':
      siteVars = {
        ...siteVars,
        ...illinoisSetupVars
      }
    case 'in':
    case 'indiana':
      siteVars = {
        ...siteVars,
        ...indianaSetupVars
      }
      break
    case 'ks':
    case 'kansas':
      siteVars = {
        ...siteVars,
        ...kansasSetupVars
      }
      break
    case 'ky':
    case 'kentucky':
      siteVars = {
        ...siteVars,
        ...kentuckySetupVars
      }
      break
    case 'la':
    case 'louisiana':
      siteVars = {
        ...siteVars,
        ...louisianaSetupVars
      }
      break
    case 'ma':
    case 'massachusetts':
      siteVars = {
        ...siteVars,
        ...massachusettsSetupVars
      }
      break
    case 'me':
    case 'maine':
      siteVars = {
        ...siteVars,
        ...maineSetupVars
      }
      break
    case 'md':
    case 'maryland':
      siteVars = {
        ...siteVars,
        ...marylandSetupVars
      }
      break
    case 'mi':
    case 'michigan':
      siteVars = {
        ...siteVars,
        ...michiganSetupVars
      }
      break
    case 'mn':
    case 'minnesota':
      siteVars = {
        ...siteVars,
        ...minnesotaSetupVars
      }
      break
    case 'ms':
    case 'mississippi':
      siteVars = {
        ...siteVars,
        ...mississippiSetupVars
      }
      break
    case 'mo':
    case 'missouri':
      siteVars = {
        ...siteVars,
        ...missouriSetupVars
      }
      break
    case 'mt':
    case 'montana':
      siteVars = {
        ...siteVars,
        ...montanaSetupVars
      }
      break
    case 'ne':
    case 'nebraska':
      siteVars = {
        ...siteVars,
        ...nebraskaSetupVars
      }
      break
    case 'nj':
    case 'newjersey':
    case 'new_jersey':
      siteVars = {
        ...siteVars,
        ...newJerseySetupVars
      }
      break
    case 'nv':
    case 'nevada':
      siteVars = {
        ...siteVars,
        ...nevadaSetupVars
      }
      break
    case 'nm':
    case 'newmexico':
    case 'new_mexico':
      siteVars = {
        ...siteVars,
        ...newMexicoSetupVars
      }
      break
    case 'nh':
    case 'new_hampshire':
    case 'newhampshire':
      siteVars = {
        ...siteVars,
        ...newHampshireSetupVars
      }
      break
    case 'nd':
    case 'north_dakota':
    case 'northdakota':
      siteVars = {
        ...siteVars,
        ...northDakotaSetupVars
      }
      break
    case 'nc':
    case 'north_carolina':
    case 'northcarolina':
      siteVars = {
        ...siteVars,
        ...northCarolinaSetupVars
      }
      break
    case 'ny':
    case 'newyork':
    case 'new_york':
      siteVars = {
        ...siteVars,
        ...newYorkSetupVars
      }
      break
    case 'oh':
    case 'ohio':
      siteVars = {
        ...siteVars,
        ...ohioSetupVars
      }
      break
    case 'or':
    case 'oregon':
      siteVars = {
        ...siteVars,
        ...oregonSetupVars
      }
      break
    case 'pa':
    case 'pennsylvania':
      siteVars = {
        ...siteVars,
        ...pennsylvaniaSetupVars
      }
      break
    case 'pr':
    case 'puertorico':
    case 'puerto_rico':
      siteVars = {
        ...siteVars,
        ...puertoRicoSetupVars
      }
      break
    case 'ri':
    case 'rhodeisland':
    case 'rhode_island':
      siteVars = {
        ...siteVars,
        ...rhodeIslandSetupVars
      }
      break
    case 'sc':
    case 'southcarolina':
    case 'south_carolina':
      siteVars = {
        ...siteVars,
        ...southCarolinaSetupVars
      }
      break
    case 'sd':
    case 'southdakota':
    case 'south_dakota':
      siteVars = {
        ...siteVars,
        ...southDakotaSetupVars
      }
      break
    case 'tn':
    case 'tennessee':
      siteVars = {
        ...siteVars,
        ...tennesseeSetupVars
      }
      break
    case 'tx':
    case 'texas':
      siteVars = {
        ...siteVars,
        ...texasSetupVars
      }
      break
    case 'ut':
    case 'utah':
      siteVars = {
        ...siteVars,
        ...utahSetupVars
      }
      break
    case 'vt':
    case 'vermont':
      siteVars = {
        ...siteVars,
        ...vermontSetupVars
      }
      break
    case 'va':
    case 'virginia':
      siteVars = {
        ...siteVars,
        ...virginiaSetupVars
      }
      break
    case 'wv':
    case 'westvirginia':
    case 'west_virgnina':
      siteVars = {
        ...siteVars,
        ...westVirginiaSetupVars
      }
      break
    case 'wa':
    case 'washington':
      siteVars = {
        ...siteVars,
        ...washingtonSetupVars
      }
      break
    case 'wi':
    case 'wisconsin':
      siteVars = {
        ...siteVars,
        ...wisconsinSetupVars
      }
      break
    case 'wy':
    case 'wyoming':
      siteVars = {
        ...siteVars,
        ...wyomingSetupVars
      }
      break
    default:
    //siteVars = headed2SetupVars;
  }

  return siteVars
}
